<template id="studyNew">
  <div class="study-root" oncontextmenu="return false;">
    <!-- ===== 指读模式 ===== -->
    <div v-if="isPoint" class="study-content">
      <el-card v-for="(item, index) in productList" :key="index" class="point-card">
        <el-image :preview-src-list="[item.sourceUrl]" :src="item.partThumbnail" oncontextmenu="return false;"
          @click="popImage(item.productCode)" @load="loadComplete"></el-image>
        <map name="planetmap" id="planetmap">
          <template>
            <area v-for="(aitem, aidx) in mapdPositionList" :key="aidx"
              :shape="aitem.selectType === 1 ? 'circle' : 'rect'" :coords="getCoords(aitem)" href="javascript:void(0)"
              @click="setCurEndTimeAndPlay(aitem.soundStart, aitem.soundEnd, aitem.soundPath)" target="_self"
              title="play sound" />
          </template>
        </map>
      </el-card>
    </div>

    <!-- ===== 网格列表模式 ===== -->
    <div v-if="!isPoint" class="grid-scroll">
      <div class="media-grid">
        <div v-for="(item, index) in productList" :key="index" class="media-card"
          :class="{ 'media-card--active': activeIndex === index }" @click="cardClick(item, index)">
          <div class="media-thumb">
            <!-- 已学标记 -->
            <div v-if="viewedSet.has(item.productCode)" class="viewed-badge">
              <i class="el-icon-check"></i>
            </div>
            <!-- 图片类型 -->
            <img v-if="item.sourceType === 3 && item.courseType !== 7" :src="item.partThumbnail" class="thumb-img"
              oncontextmenu="return false;" />
            <!-- 视频类型 -->
            <template v-if="item.sourceType !== 3">
              <img :src="item.partThumbnail" class="thumb-img" oncontextmenu="return false;" />
              <div class="play-icon"><i class="el-icon-video-play"></i></div>
            </template>
          </div>
          <div class="media-info">
            <span class="media-name">{{ item.partName || ('part ' + (index + 1)) }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- ===== 预览弹窗 ===== -->
    <el-dialog ref="previewDialog" :visible.sync="previewVisible" custom-class="preview-dialog"
      :class="{ 'preview-fullscreen': isFullscreen }" :width="isFullscreen ? '100%' : (isMobile ? '95%' : '70%')"
      :top="isFullscreen ? '0' : '5vh'" :fullscreen="isFullscreen" @close="onPreviewClose">
      <template slot="title">
        <div class="preview-header">
          <span class="preview-header__title">{{ previewTitle }}</span>
          <button class="preview-header__btn" @click="toggleFullscreen" :title="isFullscreen ? '退出全屏' : '全屏'">
            <i :class="isFullscreen ? 'el-icon-copy-document' : 'el-icon-full-screen'"></i>
          </button>
        </div>
      </template>
      <div class="preview-body" v-if="previewItem">
        <!-- 上一个按钮 -->
        <button v-show="hasPrev" class="nav-btn nav-btn--prev" @click="goPrev" title="上一个">
          <i class="el-icon-arrow-left"></i>
        </button>
        <!-- 图片预览（支持缩放/拖拽） -->
        <div v-if="previewItem.sourceType === 3 && previewItem.courseType !== 7" class="preview-img-wrap"
          @wheel.prevent="onImgWheel" @mousedown.prevent="onImgDragStart" @dblclick="toggleFullscreen">
          <img :src="previewItem.sourceUrl" class="preview-img" :style="imgTransformStyle" oncontextmenu="return false;"
            draggable="false" />
        </div>
        <!-- 视频预览 (PC) -->
        <video v-if="previewItem.sourceType !== 3 && !isMobile" ref="previewVideo" :key="previewItem.sourceUrl"
          @play="play" @fullscreenchange="fullscreenchange" @loadedmetadata="onVideoMeta"
          @timeupdate="onVideoTimeUpdate" preload="metadata" :poster="previewItem.partThumbnail" controls
          controlslist="nodownload noremoteplayback" oncontextmenu="return false" :src="previewItem.sourceUrl"
          class="preview-video">
        </video>
        <!-- 视频预览 (移动端) -->
        <video v-if="previewItem.sourceType !== 3 && previewItem.sourceType !== 7 && isMobile" ref="previewVideo"
          :key="previewItem.sourceUrl" @play="play" @fullscreenchange="fullscreenchange" @loadedmetadata="onVideoMeta"
          @timeupdate="onVideoTimeUpdate" preload="metadata" :poster="previewItem.partThumbnail" controls
          controlslist="nodownload noremoteplayback" oncontextmenu="return false" :src="previewItem.sourceUrl"
          class="preview-video">
        </video>
        <!-- 下一个按钮 -->
        <button v-show="hasNext" class="nav-btn nav-btn--next" @click="goNext" title="下一个">
          <i class="el-icon-arrow-right"></i>
        </button>
      </div>
      <!-- 底部指示器 -->
      <div class="preview-indicators" v-if="productList.length > 1">
        <span v-for="(dot, i) in productList" :key="i" class="indicator-dot"
          :class="{ 'indicator-dot--active': i === previewIndex }" @click="switchPreview(i)"></span>
      </div>
    </el-dialog>

    <!-- 隐藏预览（图片大图） -->
    <el-image ref="preimg" :src="previewDefaultUrl" :preview-src-list="previewList" class="image-show"
      @load="preload"></el-image>

    <div style="display: none;">
      <canvas ref="thrumbCanvas"></canvas>
      <audio ref="myAudio" controls="controls" crossorigin="anonymous"></audio>
    </div>
  </div>
</template>

<script>
import api from '@/utils/api'

export default {
  name: 'studyNew',
  props: {
    productList: {
      type: Array,
      default: () => ([{}])
    },
    activeName: {
      type: String
    },
    mianHeight: {
      type: Number
    },
    isPoint: {
      type: Boolean
    },
    viewedCodes: {
      type: Array,
      default: () => ([])
    }
  },
  data () {
    return {
      loading: true,
      previewList: [],
      selectIndex: 0,
      activeIndex: -1,
      previewDefaultUrl: '',
      isMobile: false,
      mapdPositionList: [],
      previewVisible: false,
      previewIndex: -1,
      videoDuration: 0,
      videoMarked: false,
      pointReadMarked: {},
      imgScale: 1,
      imgX: 0,
      imgY: 0,
      isDragging: false,
      dragStartX: 0,
      dragStartY: 0,
      dragStartImgX: 0,
      dragStartImgY: 0,
      isFullscreen: false
    }
  },
  computed: {
    viewedSet () {
      return new Set(this.viewedCodes)
    },
    previewItem () {
      if (this.previewIndex >= 0 && this.previewIndex < this.productList.length) {
        return this.productList[this.previewIndex]
      }
      return null
    },
    previewTitle () {
      if (!this.previewItem) return ''
      var name = this.previewItem.partName || ('part ' + (this.previewIndex + 1))
      return name + ' (' + (this.previewIndex + 1) + '/' + this.productList.length + ')'
    },
    hasPrev () {
      return this.previewIndex > 0
    },
    hasNext () {
      return this.previewIndex < this.productList.length - 1
    },
    imgTransformStyle () {
      return {
        transform: 'translate(' + this.imgX + 'px, ' + this.imgY + 'px) scale(' + this.imgScale + ')',
        cursor: this.imgScale > 1 ? 'grab' : 'default'
      }
    }
  },
  mounted () {
    this.isMobile = this.$equipment()
    this._keydownHandler = this.handleKeydown.bind(this)
    this._fullscreenHandler = this.handleDocumentFullscreenChange.bind(this)
    document.addEventListener('keydown', this._keydownHandler)
    document.addEventListener('fullscreenchange', this._fullscreenHandler)
    document.addEventListener('webkitfullscreenchange', this._fullscreenHandler)
    document.addEventListener('mozfullscreenchange', this._fullscreenHandler)
    document.addEventListener('MSFullscreenChange', this._fullscreenHandler)
  },
  beforeDestroy () {
    this.exitPreviewFullscreen()
    this.stopAudio()
    if (this._keydownHandler) {
      document.removeEventListener('keydown', this._keydownHandler)
    }
    if (this._fullscreenHandler) {
      document.removeEventListener('fullscreenchange', this._fullscreenHandler)
      document.removeEventListener('webkitfullscreenchange', this._fullscreenHandler)
      document.removeEventListener('mozfullscreenchange', this._fullscreenHandler)
      document.removeEventListener('MSFullscreenChange', this._fullscreenHandler)
    }
    this.onImgDragEnd()
  },
  methods: {
    stopAudio () {
      if (this._pausingFunction && this.$refs.myAudio) {
        this.$refs.myAudio.removeEventListener('timeupdate', this._pausingFunction)
        this._pausingFunction = null
      }
      if (this.$refs.myAudio) {
        this.$refs.myAudio.pause()
      }
    },
    handlePreviewClose () {
      this.stopAudio()
    },
    cardClick (item, index) {
      this.activeIndex = index
      this.switchPreview(index)
    },
    switchPreview (index) {
      // 暂停旧视频
      if (this.$refs.previewVideo) {
        this.$refs.previewVideo.pause()
      }
      // 重置视频追踪状态
      this.videoDuration = 0
      this.videoMarked = false
      // 重置图片缩放/拖拽状态
      this.resetImgTransform()
      // 切换到新 index
      this.previewIndex = index
      this.activeIndex = index
      this.previewVisible = true
      // 图片类型自动标记已学
      var item = this.productList[index]
      if (item && item.sourceType === 3 && item.courseType !== 7) {
        this.$emit('viewed', item.productCode, item.courseType)
      }
    },
    goPrev () {
      if (this.hasPrev) {
        this.switchPreview(this.previewIndex - 1)
      }
    },
    goNext () {
      if (this.hasNext) {
        this.switchPreview(this.previewIndex + 1)
      }
    },
    handleKeydown (e) {
      if (!this.previewVisible) return
      // Escape 退出全屏（全屏时不关闭弹窗）
      if (e.key === 'Escape' && this.isFullscreen) {
        e.preventDefault()
        e.stopPropagation()
        this.exitPreviewFullscreen()
        return
      }
      // 不拦截 video 元素上的左右箭头（保留快进快退）
      if (e.target && e.target.tagName === 'VIDEO') return
      if (e.key === 'ArrowLeft') {
        e.preventDefault()
        this.goPrev()
      } else if (e.key === 'ArrowRight') {
        e.preventDefault()
        this.goNext()
      }
    },
    onPreviewClose () {
      this.exitPreviewFullscreen()
      if (this.$refs.previewVideo) {
        this.$refs.previewVideo.pause()
      }
      this.videoDuration = 0
      this.videoMarked = false
      this.previewIndex = -1
      this.isFullscreen = false
    },
    toggleFullscreen () {
      var fullscreenElement = this.getFullscreenElement()
      var previewElement = this.getPreviewDialogElement()
      if (!previewElement) {
        return
      }
      if (fullscreenElement && (fullscreenElement === previewElement || previewElement.contains(fullscreenElement))) {
        this.exitPreviewFullscreen()
        return
      }
      this.requestPreviewFullscreen(previewElement)
    },
    onVideoMeta (e) {
      this.videoDuration = e.target.duration || 0
    },
    onVideoTimeUpdate (e) {
      if (this.videoMarked || !this.previewItem || this.videoDuration <= 0) return
      if (e.target.currentTime / this.videoDuration >= 0.8) {
        this.videoMarked = true
        this.$emit('viewed', this.previewItem.productCode, this.previewItem.courseType)
      }
    },
    // ===== 图片缩放/拖拽 =====
    onImgWheel (e) {
      var delta = e.deltaY > 0 ? -0.15 : 0.15
      var newScale = Math.min(Math.max(this.imgScale + delta, 0.5), 5)
      this.imgScale = Math.round(newScale * 100) / 100
      // 缩回原始大小时重置位移
      if (this.imgScale <= 1) {
        this.imgX = 0
        this.imgY = 0
      }
    },
    onImgDragStart (e) {
      if (this.imgScale <= 1) return
      this.isDragging = true
      this.dragStartX = e.clientX
      this.dragStartY = e.clientY
      this.dragStartImgX = this.imgX
      this.dragStartImgY = this.imgY
      this._onDragMove = this.onImgDragMove.bind(this)
      this._onDragEnd = this.onImgDragEnd.bind(this)
      document.addEventListener('mousemove', this._onDragMove)
      document.addEventListener('mouseup', this._onDragEnd)
    },
    onImgDragMove (e) {
      if (!this.isDragging) return
      this.imgX = this.dragStartImgX + (e.clientX - this.dragStartX)
      this.imgY = this.dragStartImgY + (e.clientY - this.dragStartY)
    },
    onImgDragEnd () {
      this.isDragging = false
      if (this._onDragMove) {
        document.removeEventListener('mousemove', this._onDragMove)
        document.removeEventListener('mouseup', this._onDragEnd)
        this._onDragMove = null
        this._onDragEnd = null
      }
    },
    resetImgTransform () {
      this.imgScale = 1
      this.imgX = 0
      this.imgY = 0
      this.isDragging = false
    },
    preload (event) {
      event.target.click()
    },
    fullscreenchange (e) {
      if (e.target.clientHeight >= window.innerHeight) {
        e.target.play()
      } else {
        e.target.pause()
      }
    },
    play (e) {
      this.launchFullscreen(e.target)
    },
    handleDocumentFullscreenChange () {
      this.isFullscreen = this.isPreviewInFullscreen()
    },
    getFullscreenElement () {
      return document.fullscreenElement ||
        document.webkitFullscreenElement ||
        document.mozFullScreenElement ||
        document.msFullscreenElement ||
        null
    },
    getPreviewDialogElement () {
      if (!this.$refs.previewDialog || !this.$refs.previewDialog.$el) {
        return null
      }
      var root = this.$refs.previewDialog.$el
      if (root.classList && root.classList.contains('preview-dialog')) {
        return root
      }
      return root.querySelector('.preview-dialog') || root
    },
    isPreviewInFullscreen () {
      var fullscreenElement = this.getFullscreenElement()
      var previewElement = this.getPreviewDialogElement()
      return !!(fullscreenElement && previewElement &&
        (fullscreenElement === previewElement || previewElement.contains(fullscreenElement)))
    },
    requestPreviewFullscreen (element) {
      var target = element || this.getPreviewDialogElement()
      if (!target) {
        return
      }
      try {
        if (target.requestFullscreen) {
          target.requestFullscreen()
        } else if (target.webkitRequestFullscreen) {
          target.webkitRequestFullscreen()
        } else if (target.mozRequestFullScreen) {
          target.mozRequestFullScreen()
        } else if (target.msRequestFullscreen) {
          target.msRequestFullscreen()
        }
      } catch (e) {
        console.log(e)
      }
    },
    exitPreviewFullscreen () {
      var fullscreenElement = this.getFullscreenElement()
      var previewElement = this.getPreviewDialogElement()
      if (!(fullscreenElement && previewElement &&
        (fullscreenElement === previewElement || previewElement.contains(fullscreenElement)))) {
        this.isFullscreen = false
        return
      }
      try {
        if (document.exitFullscreen) {
          document.exitFullscreen()
        } else if (document.webkitExitFullscreen) {
          document.webkitExitFullscreen()
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen()
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen()
        } else {
          this.isFullscreen = false
        }
      } catch (e) {
        this.isFullscreen = false
        console.log(e)
      }
    },
    launchFullscreen (element) {
      try {
        if (element.requestFullscreen) {
          element.requestFullscreen()
        } else if (element.mozRequestFullScreen) {
          element.mozRequestFullScreen()
        } else if (element.msRequestFullscreen) {
          element.msRequestFullscreen()
        } else if (element.oRequestFullscreen) {
          element.oRequestFullscreen()
        } else if (element.webkitRequestFullscreen) {
          element.webkitRequestFullScreen()
        } else {
          var docHtml = document.documentElement
          var docBody = document.body
          var videobox = element
          var cssText = 'width:100%;height:100%;overflow:hidden;'
          docHtml.style.cssText = cssText
          docBody.style.cssText = cssText
          videobox.style.cssText = cssText + ';' + 'margin:0px;padding:0px;'
          document.IsFullScreen = true
        }
      } catch (e) {
        console.log(e)
      }
    },
    popImage: function (productCode) {
      var _this = this
      _this._currentPointProductCode = productCode
      this.$nextTick(function () {
        var viewimg = document.getElementsByClassName('el-image-viewer__img')[0]
        viewimg.onload = function () {
          viewimg.setAttribute('usemap', '#planetmap')
          _this.playView(productCode, viewimg)
        }
      })
    },
    playView: function (productCode, img) {
      var _this = this
      _this.mapdPositionList = []
      _this.loading = true
      _this.$axios.get(api.getPositionsByProductCode(productCode))
        .then(res => {
          _this.mapdPositionList = res.data.result
          var currentWidth = img.clientWidth
          if (_this.mapdPositionList.length > 0) {
            _this.rate = currentWidth * 1.00 / res.data.result[0].imageWidth
          }
          _this.loading = false
          let closeEle = document.querySelector('.el-image-viewer__close')
          if (!closeEle) {
            return
          }
          closeEle.addEventListener('click', () => {
            this.handlePreviewClose()
          })
        }
        )
    },
    loadComplete (e) {
      e.target.style.width = '100%'
      e.target.style.height = 'auto'
      e.target.style.maxHeight = 'none'
    },
    getCoords: function (position) {
      if (position.selectType === 1) {
        return (position.x * this.rate).toFixed(0) + ',' + (position.y * this.rate).toFixed(0) + ',' + (position.r * this.rate).toFixed(0)
      } else {
        return (position.x * this.rate).toFixed(0) + ',' + (position.y * this.rate).toFixed(0) + ',' + (position.x1 * this.rate).toFixed(0) + ',' + (position.y1 * this.rate).toFixed(0)
      }
    },
    setCurEndTimeAndPlay: function (startTime, endTime, soundPath) {
      try {
        var _this = this
        if (_this._pausingFunction && _this.$refs.myAudio) {
          _this.$refs.myAudio.removeEventListener('timeupdate', _this._pausingFunction)
        }
        if (_this.$refs.myAudio.src !== soundPath) {
          _this.$refs.myAudio.src = soundPath
        }
        _this.$refs.myAudio.currentTime = startTime
        _this.$refs.myAudio.play()
        _this._pausingFunction = function () {
          if (_this.$refs.myAudio.currentTime >= endTime) {
            _this.$refs.myAudio.pause()
            _this.$refs.myAudio.removeEventListener('timeupdate', _this._pausingFunction)
            _this._pausingFunction = null
          }
        }
        _this.$refs.myAudio.addEventListener('timeupdate', _this._pausingFunction)
      } catch (error) {
        this.$message({ message: '播放错误', type: 'error' })
      }
    }
  },
  watch: {
    'activeName': {
      handler () {
        this.stopAudio()
        this.previewList = []
        this.previewDefaultUrl = ''
        this.previewVisible = false
        this.previewIndex = -1
        this.activeIndex = -1
      }
    }
  }
}
</script>
<style scoped lang="scss">
.study-root {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

// ===== 指读模式 =====
.study-content {
  padding: 20px 24px;
  flex: 1;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 30px;
  align-content: start;
  justify-items: center;
  overflow-y: auto;
  box-sizing: border-box;
  min-height: 0;
}

.point-card {
  width: 100%;
  max-width: 420px;
  display: block;
  margin: 0 auto;
}

::v-deep .point-card .el-card__body {
  padding: 10px;
  box-sizing: border-box;
}

::v-deep .point-card .el-image {
  width: 100%;
  display: block;
}

::v-deep .point-card .el-image__inner {
  display: block;
  width: 100%;
  height: auto;
  max-height: none;
  object-fit: contain;
  margin: 0 auto;
}

// ===== 网格滚动区域 =====
.grid-scroll {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 20px 24px;
  box-sizing: border-box;
  min-height: 0;
}

.grid-scroll::-webkit-scrollbar {
  width: 6px;
}

.grid-scroll::-webkit-scrollbar-track {
  background: transparent;
}

.grid-scroll::-webkit-scrollbar-thumb {
  background: var(--scrollbar-thumb);
  border-radius: 3px;

  &:hover {
    background: var(--scrollbar-thumb-hover);
  }
}

.study-content::-webkit-scrollbar {
  width: 6px;
}

.study-content::-webkit-scrollbar-track {
  background: transparent;
}

.study-content::-webkit-scrollbar-thumb {
  background: var(--scrollbar-thumb);
  border-radius: 3px;

  &:hover {
    background: var(--scrollbar-thumb-hover);
  }
}

.media-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
}

// ===== 媒体卡片 =====
.media-card {
  border-radius: 10px;
  background: var(--bg-white);
  border: 2px solid var(--border-lighter);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06);
  cursor: pointer;
  transition: all 0.25s ease;
  overflow: hidden;

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.12);
    border-color: var(--primary-color, #409EFF);
  }
}

.media-card--active {
  border-color: var(--primary-color, #409EFF);
  box-shadow: 0 4px 16px rgba(64, 158, 255, 0.25);
}

.media-thumb {
  position: relative;
  width: 100%;
  aspect-ratio: 11 / 6;
  overflow: hidden;
  background: var(--bg-base);
}

.thumb-img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.play-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 44px;
  height: 44px;
  background: rgba(0, 0, 0, 0.45);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;

  i {
    color: #fff;
    font-size: 24px;
    margin-left: 2px;
  }

  .media-card:hover & {
    background: rgba(64, 158, 255, 0.8);
    transform: translate(-50%, -50%) scale(1.1);
  }
}

.media-info {
  padding: 8px 10px;
  text-align: center;
}

.media-name {
  font-size: 15px;
  color: var(--text-primary, #303133);
  font-weight: 500;
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

// ===== 已学徽章 =====
.viewed-badge {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: var(--success-color, #67C23A);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
  box-shadow: 0 2px 6px rgba(103, 194, 58, 0.4);

  i {
    color: #fff;
    font-size: 14px;
    font-weight: 700;
  }
}

// ===== 预览弹窗 =====
::v-deep .preview-dialog {
  border-radius: 12px;
  overflow: hidden;
  background: var(--bg-white, #fff);

  .el-dialog__header {
    padding: 0;
    border-bottom: 1px solid var(--border-lighter);
    background: var(--bg-white, #fff);
  }

  .el-dialog__title {
    font-size: 15px;
    font-weight: 600;
    color: var(--text-primary);
  }

  .el-dialog__body {
    padding: 0;
  }
}

// 全屏模式
::v-deep .preview-fullscreen .preview-dialog {
  border-radius: 0;
  width: 100% !important;
  max-width: none;
  height: 100%;
  margin-top: 0 !important;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  .el-dialog__header {
    border-radius: 0;
  }

  .el-dialog__body {
    flex: 1;
    display: flex;
    flex-direction: column;
    min-height: 0;
  }
}

::v-deep .preview-fullscreen:fullscreen,
::v-deep .preview-fullscreen:-webkit-full-screen,
::v-deep .preview-fullscreen:-moz-full-screen,
::v-deep .preview-fullscreen:-ms-fullscreen {
  width: 100vw;
  height: 100vh;
  margin: 0 !important;
  overflow: hidden;
  background: var(--bg-white, #fff);
}

::v-deep .preview-fullscreen:fullscreen .preview-dialog,
::v-deep .preview-fullscreen:-webkit-full-screen .preview-dialog,
::v-deep .preview-fullscreen:-moz-full-screen .preview-dialog,
::v-deep .preview-fullscreen:-ms-fullscreen .preview-dialog {
  width: 100% !important;
  max-width: none !important;
  height: 100%;
  margin: 0 !important;
  border-radius: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  .el-dialog__body {
    flex: 1;
    display: flex;
    flex-direction: column;
    min-height: 0;
  }
}

.preview-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 20px;
  padding-right: 40px; // 给关闭按钮留空间
}

.preview-header__title {
  font-size: 15px;
  font-weight: 600;
  color: var(--text-primary);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.preview-header__btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 6px;
  border: none;
  background: transparent;
  color: var(--text-secondary, #909399);
  font-size: 16px;
  cursor: pointer;
  transition: all 0.2s ease;
  outline: none;
  flex-shrink: 0;

  &:hover {
    background: var(--bg-hover, #f5f7fa);
    color: var(--primary-color, #409EFF);
  }

  &:active {
    transform: scale(0.92);
  }
}

.preview-body {
  background: #000;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 300px;
  position: relative;
}

::v-deep .preview-fullscreen .preview-body,
::v-deep .preview-fullscreen:fullscreen .preview-body,
::v-deep .preview-fullscreen:-webkit-full-screen .preview-body,
::v-deep .preview-fullscreen:-moz-full-screen .preview-body,
::v-deep .preview-fullscreen:-ms-fullscreen .preview-body {
  flex: 1;
  min-height: 0;
}

.preview-img-wrap {
  width: 100%;
  height: 100%;
  min-height: 300px;
  max-height: 75vh;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  user-select: none;
}

::v-deep .preview-fullscreen .preview-img-wrap,
::v-deep .preview-fullscreen:fullscreen .preview-img-wrap,
::v-deep .preview-fullscreen:-webkit-full-screen .preview-img-wrap,
::v-deep .preview-fullscreen:-moz-full-screen .preview-img-wrap,
::v-deep .preview-fullscreen:-ms-fullscreen .preview-img-wrap {
  max-height: none;
  min-height: 0;
  flex: 1;
}

.preview-img {
  display: block;
  max-width: 100%;
  max-height: 75vh;
  object-fit: contain;
  transition: transform 0.1s ease;
  transform-origin: center center;
  will-change: transform;
}

::v-deep .preview-fullscreen .preview-img,
::v-deep .preview-fullscreen .preview-video,
::v-deep .preview-fullscreen:fullscreen .preview-img,
::v-deep .preview-fullscreen:fullscreen .preview-video,
::v-deep .preview-fullscreen:-webkit-full-screen .preview-img,
::v-deep .preview-fullscreen:-webkit-full-screen .preview-video,
::v-deep .preview-fullscreen:-moz-full-screen .preview-img,
::v-deep .preview-fullscreen:-moz-full-screen .preview-video,
::v-deep .preview-fullscreen:-ms-fullscreen .preview-img,
::v-deep .preview-fullscreen:-ms-fullscreen .preview-video {
  max-height: none;
  height: 100%;
}

.preview-video {
  display: block;
  width: 100%;
  max-height: 75vh;
  object-fit: contain;
}

::v-deep .preview-dialog.is-fullscreen {
  width: 100% !important;
  height: 100vh !important;
  margin: 0 !important;
  display: flex !important;
  flex-direction: column;
  overflow: hidden;
}

::v-deep .preview-dialog.is-fullscreen .el-dialog__header {
  flex-shrink: 0;
}

::v-deep .preview-dialog.is-fullscreen .el-dialog__body {
  flex: 1 1 auto;
  display: flex !important;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
}

::v-deep .preview-dialog.is-fullscreen .preview-body {
  flex: 1 1 auto;
  min-height: 0;
}

::v-deep .preview-dialog.is-fullscreen .preview-img-wrap {
  flex: 1 1 auto;
  min-height: 0;
  max-height: none;
}

::v-deep .preview-dialog.is-fullscreen .preview-img,
::v-deep .preview-dialog.is-fullscreen .preview-video {
  max-height: 100%;
}

::v-deep .preview-dialog.is-fullscreen .preview-indicators {
  flex-shrink: 0;
  margin-top: 0;
}

// ===== 导航按钮 =====
.nav-btn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 10;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: none;
  background: rgba(0, 0, 0, 0.35);
  color: #fff;
  font-size: 18px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.25s ease;
  backdrop-filter: blur(4px);
  outline: none;

  &:hover {
    background: rgba(0, 0, 0, 0.6);
    transform: translateY(-50%) scale(1.1);
  }

  &:active {
    transform: translateY(-50%) scale(0.95);
  }
}

.nav-btn--prev {
  left: 12px;
}

.nav-btn--next {
  right: 12px;
}

// ===== 底部指示器 =====
.preview-indicators {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px 16px;
  background: var(--bg-white, #fff);
  border-top: 1px solid var(--border-lighter, #EBEEF5);
}

.indicator-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--border-base, #DCDFE6);
  cursor: pointer;
  transition: all 0.25s ease;
  flex-shrink: 0;

  &:hover {
    background: var(--primary-color, #409EFF);
    opacity: 0.6;
  }
}

.indicator-dot--active {
  width: 20px;
  border-radius: 4px;
  background: var(--primary-color, #409EFF);

  &:hover {
    opacity: 1;
  }
}

// ===== 隐藏预览占位 =====
.image-show {
  position: absolute;
  top: -100000px;
  height: 1px;
  width: 1px;
}

// ===== 响应式 =====
@media (max-width: 1024px) {
  .study-content {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .media-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .study-content,
  .grid-scroll {
    padding: 8px;
  }
}

@media (max-width: 768px) {
  .study-content {
    grid-template-columns: 1fr;
    gap: 10px;
  }

  .point-card {
    max-width: 100%;
  }

  ::v-deep .point-card .el-card__body {
    padding: 8px;
  }

  .media-grid {
    grid-template-columns: 1fr;
    gap: 10px;
  }

  .study-content,
  .grid-scroll {
    padding: 8px 10px;
  }

  .nav-btn {
    width: 32px;
    height: 32px;
    font-size: 14px;
  }

  .nav-btn--prev {
    left: 6px;
  }

  .nav-btn--next {
    right: 6px;
  }

  .preview-indicators {
    gap: 6px;
    padding: 10px 12px;
  }

  .indicator-dot {
    width: 6px;
    height: 6px;
  }

  .indicator-dot--active {
    width: 16px;
  }
}

@import '@/styles/variables.scss';
</style>



// WEBPACK FOOTER //
// src/components/class/StudyNew.vue